{
  "removeButtonLabel": "Fjern",
  "removeDescription": "Trykk på Slett for å fjerne taggen."
}
